// Simple crypto polyfill for browser environment
(function() {
  'use strict';
  
  // Ensure crypto exists on window
  if (typeof window !== 'undefined' && !window.crypto) {
    window.crypto = {};
  }
  
  // Polyfill getRandomValues if not available
  if (typeof window !== 'undefined' && window.crypto && !window.crypto.getRandomValues) {
    window.crypto.getRandomValues = function getRandomValues(arr) {
      if (arr.length > 65536) {
        throw new QuotaExceededError('Requested length exceeds 65536 bytes');
      }
      
      for (let i = 0; i < arr.length; i++) {
        arr[i] = Math.floor(Math.random() * 256);
      }
      return arr;
    };
  }
})();

// Export for module usage
export const getRandomValues = (typeof window !== 'undefined' && window.crypto?.getRandomValues) 
  ? window.crypto.getRandomValues.bind(window.crypto)
  : function(arr) {
      if (arr.length > 65536) {
        throw new QuotaExceededError('Requested length exceeds 65536 bytes');
      }
      
      for (let i = 0; i < arr.length; i++) {
        arr[i] = Math.floor(Math.random() * 256);
      }
      return arr;
    };
